<template>
    <div class="activeAuthListWrap">
        <!-- <h3>{{formObj.state}}</h3> -->
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item label="申请活动总数">
                        共{{customerTotal}} 场 
                    </el-form-item>
                    <el-form-item>
                        <el-input  placeholder="注册手机号/公司名称" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="审核状态" v-model="formObj.state" @change="multiSearchClick">
                            <el-option label="所有状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in authResultOptions" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="序号" width="70">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="活动名称">
                    <template slot-scope="scope">{{ scope.row.conferenceName }}</template>
                </el-table-column>
                <el-table-column label="活动申请公司">
                    <template slot-scope="scope">{{ scope.row.companyName }}</template>
                </el-table-column>
                <el-table-column label="注册手机号" >
                    <template slot-scope="scope">{{ scope.row.phone }}</template>
                </el-table-column>
                <el-table-column label="提交活动申请时间" >
                    <template slot-scope="scope">{{ scope.row.conferenceInviteStartTime }}</template>
                </el-table-column>
                <el-table-column label="身份">
                    <template slot-scope="scope">
                    {{ scope.row.userType |turnValToText('user_type')}}
                    <!-- <span :class="{blue:scope.row.identity=='品牌商'}"></span> -->
                    </template>
                </el-table-column>
                
                <el-table-column label="审核状态">
                    <template slot-scope="scope">
                        <span :class="{grey:scope.row.state=='never',red:scope.row.state=='p',green:scope.row.state=='y',orange_lighter:scope.row.state=='n'}">{{ scope.row.state |turnValToText('auth_result')}}</span>
                    
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130">
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <span class="spanBtn" @click="toDetail(scope.row)" v-if="functionViewActiveDetail">详情</span>
                            <span class="spanBtn orange" @click="toDetail(scope.row)" v-if="scope.row.state=='p'&&functionActiveApplyAuth">去审核</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                currentAuthList:{},
                isLoading:false,
                tableData:[],
                lastPage:'',
                customerTotal:'-',
                formObj:{
                    fuzzyQuery:'',
                    state:'',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                total:0,
            }
        },
        computed: {
            functionViewActiveDetail(){
                return utils.getCurrentFunction().indexOf("viewActiveDetail")>-1
            },
            functionActiveApplyAuth(){
                return utils.getCurrentFunction().indexOf("activeApplyAuth")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            
        },
        methods: {
            getParams(){
              this.lastPage=this.$route.query.from  
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.formObj.fuzzyQuery,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    state: this.formObj.state,
                    num: this.searchObj.num,
                    page: 1,
                }
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                _this.isLoading=true
                ajaxPost('/admin/getconferenceReviewList', _this.searchObj).then(function(res) {
                    _this.tableData=res.data.reviewList?res.data.reviewList:[]
                    _this.total=parseInt(res.data.total) 
                    _this.customerTotal=res.data.total
                    _this.isLoading=false
                }, function(res) {
                    _this.isLoading=false
                })
                // _this.tableData=json.tableData
            },
            toDetail(list) {
                let _this=this
                console.log(list)
                utils.setSearchObjToSession(_this.searchObj)
                // let appId=1
                let conferenceId=list.conferenceId
                // let invitePartnerId=1
                // let inviteUserId=list.userId
                // this.$router.push({name: 'activeAuthDetail',params: { appId: appId,conferenceId:conferenceId,invitePartnerId:invitePartnerId,inviteUserId:inviteUserId }})
                this.$router.push({name: 'activeAuthDetail',params: { conferenceId:conferenceId}})
            },
        },
        created() {
            console.log("执行created")
        	//获取session里存储的搜索条件，并赋值给当前表单
            
            this.getParams()
            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                this.formObj.fuzzyQuery=_this.searchObj.fuzzyQuery
                this.formObj.state=_this.searchObj.state
            }else if(_this.lastPage=='home'){
                _this.searchObj.state='p'
                this.formObj.state=_this.searchObj.state
    
            }
            this.getTableLists()
        
        },
        mounted(){
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .activeAuthListWrap {
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
               float: right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem; padding-top:0;
       }
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/auth.vue